import { apiClient } from './client';

export const audioApi = {
  getConfig: () => apiClient.get('/audio/config'),
  updateConfig: (data: unknown) => apiClient.put('/audio/config', data),
  getProviders: () => apiClient.get('/audio/providers'),
  getProviderMeta: (id: string) => apiClient.get(`/audio/providers/${id}/meta`),
  getVoiceCallProviderMeta: (id: string) => apiClient.get(`/audio/voice-call/providers/${id}/meta`),
};
